export default {
    products: [],
    productsLoading: false,
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters
}

function setInitialFilters() {
    return {
        name: null,
        hasProductTypeComponents: false
    }
}